// Mirrors `assistant.state` from the voice contract; the backend sends every transition
const aiAssistantStates = {
    IDLE: 'IDLE',
    LISTENING: 'LISTENING',
    THINKING: 'THINKING',
    SPEAKING: 'SPEAKING',
    // Only while a proposal is waiting for an answer
    WAITING: 'WAITING',
};

export default aiAssistantStates;
